import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

const OfferSystem = () => {
  const { t } = useLang();
  const paragraphs = t("offer.paragraphs");
  const offers = t("offer.offers");
  return (
    <section className="py-24 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[13px] font-semibold tracking-[0.18em] uppercase text-[#FF5C00]">{t("offer.eyebrow")}</p>
            <h2 className="mt-4 text-[32px] md:text-[42px] font-bold tracking-tight text-white leading-[1.1]">{t("offer.heading")}</h2>
            {paragraphs.map((p, i) => (<p key={i} className="mt-5 text-[16px] leading-relaxed text-neutral-400">{p}</p>))}
            <Link to="/boka" className="group mt-8 inline-flex items-center gap-2 bg-[#1A8A4A] hover:bg-[#20A458] text-white text-[15px] font-semibold px-6 py-3 rounded-xl transition-colors">
              {t("offer.cta")}<ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
          <div>
            <div className="flex flex-col gap-3">
              {offers.map((o, i) => {
                const accepted = i === offers.length - 1;
                return (
                  <div key={o.name} className={`flex items-center justify-between rounded-xl border bg-[#181818] px-5 py-4 transition-all duration-300 hover:-translate-y-0.5 ${accepted ? "border-[#1A8A4A]/50" : "border-[#2A2A2A]"}`}>
                    <div><div className="text-[16px] font-semibold text-white">{o.name}</div><div className="text-[13px] text-neutral-500 mt-0.5">{o.role}</div></div>
                    <div className="text-right"><div className="text-[16px] font-semibold text-white">{o.price}</div><div className={`text-[13px] mt-0.5 ${accepted ? "text-[#2fbe6e]" : "text-[#FF7A2F]"}`}>{o.status}</div></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferSystem;
